import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { useTheme } from '../hooks/useTheme';

const Header = () => {
    const { user, logout } = useAuth();
    const { darkMode, toggleTheme } = useTheme();

    return (
        <header className={`${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} shadow-sm border-b`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="flex items-center">
                        <h1 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                            💪 Workout Tracker
                        </h1>
                    </div>

                    <div className="flex items-center gap-4">
                        {/* Theme Toggle Button */}
                        <button
                            onClick={toggleTheme}
                            className={`p-2 rounded-lg transition-colors ${darkMode
                                    ? 'bg-gray-700 text-yellow-400 hover:bg-gray-600'
                                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                }`}
                            title={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                        >
                            {darkMode ? '☀️' : '🌙'}
                        </button>

                        <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'} hidden sm:block`}>
                            Welcome, {user?.displayName}
                        </span>
                        {user?.photoURL ? (
                            <img
                                src={user?.photoURL}
                                alt={user?.displayName || 'Profile'}
                                className="w-8 h-8 rounded-full object-cover"
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                }}
                            />
                        ) : null}
                        {/* Fallback avatar */}
                        <div
                            className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white text-sm font-bold"
                            style={{ display: user?.photoURL ? 'none' : 'flex' }}
                        >
                            {user?.displayName ? user.displayName.charAt(0).toUpperCase() : 'U'}
                        </div>
                        <button
                            onClick={logout}
                            className={`${darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'} text-sm font-medium`}
                        >
                            Sign Out
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;